import "./FormLogin.scss";
import { useState } from "react";
import { checkEmailValid } from "../../helper/checkEmail";
import { checkExistEmail, loginUser } from "../../services/login/login";
import { setCookie } from "../../helper/cookie";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { RiBearSmileLine } from "react-icons/ri";
import { Link, useNavigate } from "react-router-dom";
import { Button, Checkbox, ConfigProvider, Form, Input, Tag } from "antd";
import { useDispatch } from "react-redux";
import { loginActions } from "../../actions/login";

function FormLogin() {
  const validateMessages = {
    string: {
      min: "${label} phải có ít nhất ${min} kí tự.",
    },
  };

  const [loading, setLoading] = useState(false);
  const [welcome, setWelcome] = useState(true);
  const [emailValid, setEmailValid] = useState(true);
  const [emailExist, setEmailExist] = useState(true);
  const [checkLogin, setCheckLogin] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    setLoading(true);

    //Reset các trạng thái
    setWelcome(true);
    setEmailValid(true);
    setEmailExist(true);
    setCheckLogin(null);

    const email = e.email;
    const password = e.password;
    const validEmail = await checkEmailValid(email);
    const existEmail = await checkExistEmail(email);
    const loginCheck = await loginUser(email, password);

    setTimeout(() => {
      setWelcome(false); //Ẩn tag mặc định. Vì ban đầu là set true để hiện

      if (!validEmail) setEmailValid(false);
      if (existEmail.length > 0) {
        setCheckLogin(false);

        if (loginCheck.length > 0) {
          setCheckLogin(true);

          const user = loginCheck[0];

          setTimeout(() => {
            setCookie("id", user.id, 1);
            setCookie("email", email, 1);
            setCookie("fullName", user.fullName, 1);
            setCookie("token", user.token, 1);
            dispatch(loginActions(true));
            navigate("/", { replace: true });
          }, 1000);
        }
      } else setEmailExist(false);
      setLoading(false);
    }, 1200);
  };

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Button: {
              defaultBg: "#000",
              defaultColor: "#fff",
              defaultHoverColor: "#000",
              defaultHoverBorderColor: "#000",
              defaultActiveBorderColor: "#000",
              defaultActiveColor: "#000",
              fontWeight: 700,
            },
            Checkbox: {
              colorPrimary: "#000",
              colorPrimaryHover: "#000",
            },
          },
        }}
      >
        <Form
          name="basic"
          size="large"
          layout="vertical"
          requiredMark={false}
          autoSave="on"
          autoComplete="on"
          validateMessages={validateMessages}
          onFinish={handleSubmit}
          className="form"
        >
          <div className="form-tag">
            {welcome && (
              <Tag
                style={{
                  background: "#fff",
                  color: "#000",
                  borderColor: "#000",
                }}
                icon={<RiBearSmileLine style={{ marginRight: "5px" }} />}
                className="form-status"
              >
                Chào mừng bạn đến với Depop
              </Tag>
            )}

            {emailValid === false && (
              <Tag
                icon={<ExclamationCircleOutlined />}
                color="warning"
                className="form-status"
              >
                Email không đúng định dạng
              </Tag>
            )}

            {emailValid && emailExist === false && (
              <Tag
                icon={<ExclamationCircleOutlined />}
                color="volcano"
                className="form-status"
              >
                Email không tồn tại
              </Tag>
            )}

            {emailValid && emailExist && checkLogin === false && (
              <Tag
                icon={<CloseCircleOutlined />}
                color="error"
                className="form-status"
              >
                Sai tài khoản hoặc mật khẩu
              </Tag>
            )}

            {emailValid && emailExist && checkLogin === true && (
              <Tag
                icon={<CheckCircleOutlined />}
                color="success"
                className="form-status"
              >
                Đăng nhập thành công, vui lòng đợi trong giây lát
              </Tag>
            )}
          </div>

          <Form.Item
            label="Email"
            style={{ fontWeight: 500 }}
            name="email"
            rules={[{ required: true, message: "Vui lòng nhập email!" }]}
          >
            <Input placeholder="name@example.com" className="form-email" />
          </Form.Item>

          <Form.Item
            label="Mật khẩu"
            style={{ fontWeight: 500 }}
            name="password"
            rules={[
              { required: true, message: "Vui lòng nhập mật khẩu!" },
              { type: "string", min: 8 },
            ]}
          >
            <Input.Password
              variant="borderless"
              placeholder="name1234"
              className="form-password"
            />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked" label={null}>
            <div className="form-checkbox">
              <Checkbox className="checkbox">Remember me</Checkbox>
              <Link className="forgot-pss">
                <div>Quên mật khẩu?</div>
              </Link>
            </div>
          </Form.Item>

          <Form.Item label={null}>
            <Button
              htmlType="submit"
              loading={loading}
              disabled={loading}
              className="form-btnLogin"
            >
              Đăng nhập
            </Button>
          </Form.Item>
        </Form>
      </ConfigProvider>
    </>
  );
}

export default FormLogin;
